import { useReducer, useEffect, useRef } from "react";
import { AuthContext } from "./AuthContext";
import { authReducer, initialState, AUTH_EVENTS } from "./authReducer";
import api, { setAccessToken } from "@/api/client";
import { dedupedRefresh } from "./authController";
import { getAuth } from "firebase/auth";

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, initialState);

  // prevent stale responses overriding newer ones
  const requestIdRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestIdRef.current;
    dispatch({ type: AUTH_EVENTS.RESTORE });

    dedupedRefresh(api)
      .then((res) => {
        if (requestId !== requestIdRef.current) {
          return;
        }

        setAccessToken(res.data.accessToken);
        const photoURL = getAuth().currentUser?.photoURL ?? null;

        dispatch({
          type: AUTH_EVENTS.RESTORE_SUCCESS,
          user: res.data.user,
          photoURL,
        });
      })
      .catch((err) => {
        if (requestId !== requestIdRef.current) {
          return;
        }

        dispatch({ type: AUTH_EVENTS.RESTORE_FAIL });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
}
